import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,Events,ViewController} from 'ionic-angular';
import { ModalController } from "ionic-angular";
import {
  TechnicalModalPage
} from "../../modals/technicals/technicals.modal";

import { ProductServiceProvider } from "../products/product.service";
import { APIServiceProvider } from "./../../common/services/api.service";

import { ProductsPage } from "../products/products";
import { HelperServiceProvider } from "./../../common/services/helper.service";
import { AddOrderServiceProvider } from "./../addorder/add-order.service";
import { ProductModal } from "../products/productmodal";


/**
 * Generated class for the ProductSubstitutePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

 @IonicPage()
 @Component({
   selector: 'page-product-substitute',
   templateUrl: 'product-substitute.html',
 })
 export class ProductSubstitutePage {
   public productList: any = [];
   public actual_products: any = [];
   queryText: string;
   requestType: any = "products";
   requestIndex: any = null;
   public products: any = [];

   public technicals:any = [];


   search: any = null;

   hasLoadData: any = true;

   public technical_code = null;
   public technical_name = null;
   public product_field_app_name = null;

   public composition_name :any = [];

   public postParams: any = {
     limit: 10,
     // technical_code : this.navParams.get('technical_code'),
     technical_code:null,
     search: this.search
   };



   constructor(
     public navCtrl: NavController,
     public navParams: NavParams,
     public productService: ProductServiceProvider,
     public modalCtrl: ModalController,
     public apiService: APIServiceProvider,
     public helperService: HelperServiceProvider,
     public addOrderService: AddOrderServiceProvider,
     public viewCtrl: ViewController,
     public events: Events,


     ) {
   }

   ionViewDidLoad() {
     this.technical_code = this.navParams.get('technical_code');
     this.technical_name = this.navParams.get('technical_name')
     this.product_field_app_name = this.navParams.get('product_field_app_name')

     // console.log(this.technical_code);
     // this.composition_name= this.navParams.get("products")
     // console.log(this.composition_name)

     this.getSubProducts();
   }

   
   getSubProducts() {

     this.apiService
     .post(
       "technical/get_substitute",
       { limit: 10, technical_code:this.navParams.get('technical_code'), search: this.search },null,false
       )
     .subscribe(products => {
       this.productService.productResponse = products;
       this.productService.products = products["data"];

       if (products["data"].length < 10) {
         this.hasLoadData = false;
       } else {
         this.hasLoadData = true;
       }
     });
   }

   doInfiniteScrollSub(infiniteScroll) {
     if (
       !this.productService.productResponse.next_page_url ||
       this.productService.productResponse.next_page_url === "" ||
       this.productService.productResponse.next_page_url === null ||
       this.productService.productResponse.next_page_url === "null"
       ) {
       return;
   }

   this.apiService

   .post(
     "technical/get_substitute",
     { limit: 10, technical_code:this.navParams.get('technical_code')},this.productService.productResponse.next_page_url,
     false
     )
   .subscribe(products => {
     infiniteScroll.complete();

     if (products["data"].length < 10) {
       this.hasLoadData = false;
     } else {
       this.hasLoadData = true;
     }

     this.productService.productResponse = products;
     this.productService.products = this.productService.products.concat(
       products["data"]
       );
   });
 }

 selectProductSub(product) {
   if (this.requestType === "products") {
     this.productService.productObj.product_field_app_name =
     product.product_field_app_name;
     this.productService.productObj.product_weight = product.product_weight;
     this.productService.productObj.product_selling_price =
     product.product_selling_price;
     this.productService.productObj.total =
     parseFloat(product.product_selling_price) *
     parseFloat(this.productService.productObj.quantity);

     this.productService.productObj.total = parseFloat(
       this.productService.productObj.total
       ).toFixed(2);
   }

   if (this.requestType === "addorder") {
     product.requestIndex = this.requestIndex;
     this.events.publish("addorderproduct-selected", product);
   }

   // this.navCtrl.pop();

   this.navCtrl.push(ProductsPage, { type: "products" });

 }

 showTechnicalDetailsModal(products) {
   console.log(products);
   let modalObject = this.modalCtrl.create(
     TechnicalModalPage, {
       technical_name: products['technical_name']

     }

     );

   modalObject.present();
 }

 goToProducts() {
   this.navCtrl.push(ProductModal);

 }



}



// WEBPACK FOOTER //
// ./src/pages/product-substitute/product-substitute.ts